export const adminImpersonation = "/admin/impersonation";
